export default __webpack_public_path__ + "static/media/creatura-logos_horizontal.026cb38c.png";